import { resourceText } from 'src/app/shared/services/localization';
import { AfterViewInit, Component, OnInit, LOCALE_ID, Inject } from '@angular/core';
import { Notification } from 'src/app/shared/models/notification.model';
import { GlobalService } from 'src/app/shared/services/global.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-push-notifications',
    templateUrl: './push-notifications.component.html',
    styleUrls: ['./push-notifications.component.scss'],
    standalone: false
})
export class PushNotificationsComponent implements OnInit, AfterViewInit {

  userId: string = '';
  notifications: Notification[] = [];
  loadError = false;
  confirmDelete: boolean = false;
  isLoading: boolean = true;
  constructor(@Inject(LOCALE_ID) private locale: string, public globalService: GlobalService,
              private notificationService: NotificationService,
              private router: Router
  ) { }

  async ngOnInit() {
    this.isLoading = true;
    this.loadError = false;
    this.notifications = [];
    try {
      this.userId = localStorage.getItem('CSBarcodeID');
      if (!this.userId || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(this.userId)) { this.userId = ''; return; }
      const notifications = await this.notificationService.viewNotifications(this.userId);
      this.notifications = Array.isArray(notifications) ? notifications : [];
      this.notifications.forEach(a => {
        const date = new Date(a.notificationDate);
        a.notificationDate = a.notificationDate && !isNaN(date.getTime()) ? formatDate(date, 'MM/dd/yy', this.locale).trim() : '';
        a['selected'] = false;
      });
    } catch {
      this.loadError = true;
    } finally {
      this.isLoading = false;
    }
  }

  ngAfterViewInit(): void {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.selectedOption = "NOTIFICATIONS";
    this.globalService.screenHeader = resourceText('NOTIFICATION');
  }

  signIn(): void {
    const tenant = localStorage.getItem('tenant') || this.globalService.currentTenant;
    void this.router.navigate(['/' + tenant + '/login'], {queryParams:{returnUrl:'/' + tenant + '/notifications'}});
  }

  ToggleSelection(notification)
  {
    notification.selected = !notification.selected;
  }

  ApplySelectOperation(){
      let isAllSelected = this.isAllSelected();
      this.notifications?.map(a => {
      a["selected"] = ! isAllSelected;
    })
  }

  getSelectOperationText()
  {
    if (this.isAllSelected() == true)
      return this.globalService.Get("UNSELECTALL");
    else
      return this.globalService.Get("SELECTALL");
  }

  isAllSelected() {
    return (this.notifications?.findIndex(a => a["selected"] == false) == -1 && this.notifications?.length > 0);
  }

  isAnySelected() {
    return (this.notifications?.findIndex(a => a["selected"] == true) >= 0);
  }

  getSelectedCount() {
    let selectionCount = this.notifications?.filter(a => a["selected"]).length;
    let totalCount = this.notifications?.length;
    return resourceText('SELECTED_NOTIFICATIONS_VALUE0_VALUE1', {value0:(selectionCount),value1:(totalCount)});
  }

  openNotification(notification) {
    notification.isOpen = true;
    this.router.navigate(['/admin/cms/notification/' + notification?.messageUUID ]);
  }

  async deleteSelection() {
    let ret = await this.notificationService.deleteNotifications(this.userId, this.notifications?.filter(a => a["selected"] == true).map(b => b.messageUUID));
    if (ret == "success")
      this.notifications = this.notifications?.filter(a => a["selected"] != true);
    this.confirmDelete = false;
  }

}

